// 文件下载工具（2026-08-02 文件名事故后统一走这里）
// 为什么不用 <a href target="_blank"> 或直接打开签名 URL：
//   Storage 对非 ASCII download 参数会产出畸形 Content-Disposition（裸 percent 编码
//   的 filename 值），浏览器照原文存盘 → 文件名带 % → Office 把路径当 URL 二次
//   解码 → "无法读取"。blob 下载 + a.download 自命名完全绕开响应头，文件名 100% 可控。
// 注意：blob: URL 与页面同源，a.download 才生效（跨域直链时该属性被浏览器忽略）。

/** fetch 签名 URL → blob → 以指定文件名触发浏览器下载 */
export async function downloadFile(url: string, filename: string): Promise<void> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`下载失败（HTTP ${res.status}）`);
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // 延迟回收，给浏览器留足拉起下载的时间
    setTimeout(() => URL.revokeObjectURL(objUrl), 10_000);
  }
}
